var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-5", attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    elevation: "0",
                    dense: ""
                  }
                },
                [
                  _c("span", [_vm._v("New Stock")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { text: "", loading: _vm.stockPosting },
                      on: { click: _vm.storeStock }
                    },
                    [_c("span", [_vm._v("ADD")])]
                  ),
                  _c("v-icon", [_vm._v("mdi-clipboard")])
                ],
                1
              ),
              _vm.stockPostSuccess
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { type: "success", dismissible: "" }
                    },
                    [
                      _c("span", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.stockPostSuccess))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.stockPostErrors.errors
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { type: "error", dismissible: "" }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.stockPostErrors.errors.first()))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Stock Code",
                  value: _vm.stockId,
                  readonly: "",
                  dense: "",
                  outlined: "",
                  "error-messages": _vm.stockPostErrors.id || []
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.stockCatList,
                  "error-messages": _vm.stockPostErrors.stock_category_id || [],
                  loading: _vm.stockCatGetting,
                  label: "Stock Category",
                  filter: _vm.stockCatFilter,
                  outlined: "",
                  dense: "",
                  "allow-overflow": false,
                  "item-value": "id",
                  "return-object": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.stockCategory,
                  callback: function($$v) {
                    _vm.stockCategory = $$v
                  },
                  expression: "stockCategory"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Product Name",
                  "error-messages": _vm.stockPostErrors.product_name || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.productName,
                  callback: function($$v) {
                    _vm.productName = $$v
                  },
                  expression: "productName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Brand Name",
                  "error-messages": _vm.stockPostErrors.brand_name || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.brandName,
                  callback: function($$v) {
                    _vm.brandName = $$v
                  },
                  expression: "brandName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Product Type",
                  "error-messages": _vm.stockPostErrors.product_type || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.productType,
                  callback: function($$v) {
                    _vm.productType = $$v
                  },
                  expression: "productType"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "2", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Description",
                  "error-messages": _vm.stockPostErrors.description || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }